
import {Breadcrumbs, Btn, H5} from "../../AbstractElements";
import {Card, CardBody, CardHeader, Col, Container, Row} from "reactstrap";
import {useState} from "react";
import {NasabahDataTable} from "../../Components/DataTables/NasabahDataTable";
import {NasabahFormDrawer} from "../../Components/Drawers/NasabahFormDrawer";


export const ViewsManageNasabah = () => {
    const initialDrawerState = {
        forms: false,
        editId: 0
    }

    const initialRefreshState = {
        nasabahDataTable: false,
    }

    const [drawerState, setDrawerState] = useState(initialDrawerState)
    const [refreshState, setRefreshState] = useState(initialRefreshState)

    const closeAllDrawer = () => {
        refreshAllState()
        setDrawerState(initialDrawerState)
    }

    const refreshAllState = () => {
        setRefreshState({
            ...initialRefreshState,
            nasabahDataTable: true
        })
    }
    return (
        <>
            <Breadcrumbs parent="Nasabah" title="Manage Nasabah" mainTitle="Manage Nasabah"/>
            <Container fluid={true} className="datatables">
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardHeader className="pb-0">
                                <Row className="justify-content-between">
                                    <Col md={"auto"}>
                                        <H5>Manage Nasabah</H5>
                                    </Col>
                                    <Col md={"auto"}>
                                        <Btn attrBtn={{
                                            color: "secondary", className: "m-r-15", onClick: (e) => {
                                                setDrawerState({...drawerState, forms: true})
                                            }
                                        }}>Nasabah Baru</Btn>
                                    </Col>
                                </Row>
                            </CardHeader>
                            <CardBody>
                                <NasabahDataTable drawerState={drawerState} setDrawerState={setDrawerState}
                                                  refresh={refreshState.nasabahDataTable}
                                                  onRefreshFinish={() => setRefreshState(initialRefreshState)}/>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <NasabahFormDrawer id={drawerState.editId} open={drawerState.forms} onClose={closeAllDrawer}/>
        </>
    )

}